<template>
	<section class="app-container bg--secondary">
		<div class="container">
			<h2 v-if="!confirmed">Confirming your account...</h2>
            <error-list v-bind:errors="error_results.non_field_errors"></error-list>
            <error-list v-bind:errors="error_results.token"></error-list>
            <error-list v-bind:errors="error_results.uid"></error-list>

			<div v-if="confirmed">
				<div class="alert alert-info">
					<h2>Your account has been confirmed.</h2>
					Please sign in to start using Odonata Central.
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'ConfirmAccount',
		data: function(){
			return {
				confirmed: false,
				error_results: [],
			};
		},
		mounted(){
			var self = this;
			this.API({
                endpoint: 'auth/users/activation',
                funcThen: function(response){
                	self.confirmed = true;
                },
                funcCatch: function(error){
                    if (error.response && error.response.data) {
                        self.error_results = error.response.data;
                    }
                    else{
                        console.log(error);
                    }
                },
                isPost:true,
                postData: { 
                	uid: self.$route.params.uid,
					token: self.$route.params.token,
                }
            });
		},
		methods:{
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/pages/ConfirmAccount.vue